import FilterStore from "./FilterStore";
import LicenseStore from "./LicenseStore";
import QueryStore from "./QueryStore";
export default class AppStore {
  filter = new FilterStore(this);
  query = new QueryStore(this);
  license = new LicenseStore(this);
}
